import React from 'react'
import { TextField } from '@material-ui/core'
import { makeStyles } from "@material-ui/core/styles"
import styles from './custom_input.module.css'


export default function CustomInput(props) {

    const useStyles = makeStyles(theme => ({
        root: {
            width: "100% !important",
            "& .MuiFormLabel-root": {
                color: "rgba(46, 39, 68, 0.4)",
                backgroundColor: "white",
                borderRadius: "14px",
                fontSize: "1rem",
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "white"
            },
            "& .MuiInputBase-root": {
                backgroundColor: "white",
                borderRadius: "24px",
                /*      display: "flex" */
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#073748"
            },
            "& .MuiOutlinedInput-adornedEnd": {
                paddingRight: props.isEmail ? "4px" : "14px"
            },
            "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                padding: "5px"
            },
            "& .MuiInputBase-input::placeholder": {
                color: "#b4c8ca",
            }
        }
    }))

    const classes = useStyles()
    return (

        <TextField
            defaultValue={(props.setInputValue !== undefined && props.setInputValue) ? props.setInputValue : ""}
            variant="outlined"
            placeholder={props.placeHolder}
            className={classes.root}
            onChange={props.value}
            onKeyPress={props.enterPressed}
            InputProps={{
                endAdornment: (
                    props.endAdornment
                ),
                startAdornment: (
                    props.startAdornment
                )
            }}
        />
    );
}